import {Link, useLocation} from "react-router-dom";
import logoImage from "../assets/logo.png";
import styled from "styled-components";

const HeaderContainer = styled.header`
  display: flex;
  align-items: center;
`;

const HeaderLogo = styled.img`
  width: 189px;
  height: 105px;
`;

const HeaderNav = styled.nav`
  display: flex;
  justify-content: space-between; /* 항목 사이에 동일한 간격을 둠 */
  flex-grow: 1; /* 네비게이션이 가용 공간을 모두 차지하도록 설정 */
  margin-top: 33px;
`;

const HeaderLink = styled(Link)`
  color: #333;
  text-decoration: none;
  flex: 1; /* 모든 메뉴 항목이 동일한 넓이로 확장됨 */
  text-align: center; /* 텍스트를 가운데 정렬 */
  font-weight: bold;
  font-family: "Droid Serif W01 Regular", serif;
  font-size: 14px;
  //transition: background-color 0.3s;
  //
  //&:hover {
  //  background-color: #f0f0f0;
  //}
`;

export default function Header() {
  const location = useLocation(); // Access current route

  const handleLinkClick = (event, linkTo) => {
    if (location.pathname === linkTo) {
      event.preventDefault(); // Prevent navigation if it's the same route
    }
  };

  return (<HeaderContainer>
    <Link to="/">
      <HeaderLogo src={logoImage} alt="MRI Lab Logo"/>
    </Link>
    <HeaderNav>
      <HeaderLink to="/people" onClick={(e) => handleLinkClick(e, "/people")}>
        PEOPLE
      </HeaderLink>
      <HeaderLink to="/publications" onClick={(e) => handleLinkClick(e, "/publications")}>
        PUBLICATIONS
      </HeaderLink>
      <HeaderLink to="/research" onClick={(e) => handleLinkClick(e, "/research")}>
        RESEARCH
      </HeaderLink>
      <HeaderLink to="/facility" onClick={(e) => handleLinkClick(e, "/facility")}>
        FACILITY
      </HeaderLink>
      <HeaderLink to="/album" onClick={(e) => handleLinkClick(e, "/album")}>
        ALBUM
      </HeaderLink>
      <HeaderLink to="/contact" onClick={(e) => handleLinkClick(e, "/contact")}>
        CONTACT
      </HeaderLink>
    </HeaderNav>
  </HeaderContainer>);
}
